const isImageByMimeType = (mimeType: string): boolean => {
  return mimeType.startsWith('image')
}

export default isImageByMimeType
